export const RCS_TYPES = [
    { value: 50, label: '통합 텍스트' },
    { value: 51, label: '통합 이미지 T (900×800)' },
    { value: 52, label: '통합 이미지 M (900×500)' },
    { value: 1, label: '텍스트' },
    { value: 0, label: '이미지' },
];
export const isRcsText = (type) => [1, 50].includes(Number(type));
export const rcsImageSizes = (type) => Number(type) === 51 ? [{ width: 900, height: 800 }]
    : Number(type) === 52 ? [{ width: 900, height: 500 }]
    : isRcsText(type) ? [] : [{ width: 400, height: 240 }, { width: 500, height: 300 }];
export const rcsSizeLabel = (type) => rcsImageSizes(type).map(({ width, height }) => width + '×' + height).join(' 또는 ');
export const rcsImageSizeLimit = () => 300000;
export const rcsImageSizeLimitLabel = () => '최대 300KB';
export const validateRcsFile = (file, type) => new Promise((resolve) => {
    if (!file || isRcsText(type) || !/\.jpe?g$/i.test(file.name) || file.size > rcsImageSizeLimit(type)) {
        alert(rcsImageSizeLimitLabel(type) + '의 JPG/JPEG 이미지를 선택해 주세요.');
        resolve(false);
        return;
    }
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
        const valid = rcsImageSizes(type).some(({ width, height }) => image.naturalWidth === width && image.naturalHeight === height);
        URL.revokeObjectURL(url);
        if (!valid) alert(rcsSizeLabel(type) + 'px 이미지만 선택할 수 있습니다.');
        resolve(valid);
    };
    image.onerror = () => { URL.revokeObjectURL(url); alert('이미지를 읽을 수 없습니다.'); resolve(false); };
    image.src = url;
});

/* 특정 용도(슬라이드 타입)가 정해지지 않은 이미지 등록 화면에서는 유저가 규격을 미리
   고를 필요 없이, 등록 가능한 규격(400×240, 500×300, 900×800, 900×500) 중 하나인지만 확인한다. */
export const ALL_RCS_IMAGE_SIZES = [
    { width: 400, height: 240 },
    { width: 500, height: 300 },
    { width: 900, height: 800 },
    { width: 900, height: 500 },
];
export const allRcsSizeLabel = () => ALL_RCS_IMAGE_SIZES.map(({ width, height }) => width + '×' + height).join(', ');
export const validateAnyRcsFile = (file) => new Promise((resolve) => {
    if (!file || !/\.jpe?g$/i.test(file.name) || file.size > rcsImageSizeLimit()) {
        alert(rcsImageSizeLimitLabel() + '의 JPG/JPEG 이미지를 선택해 주세요.');
        resolve(false);
        return;
    }
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
        const valid = ALL_RCS_IMAGE_SIZES.some(({ width, height }) => image.naturalWidth === width && image.naturalHeight === height);
        URL.revokeObjectURL(url);
        if (!valid) alert('등록 가능한 이미지 크기가 아닙니다. (' + allRcsSizeLabel() + 'px 중 하나여야 합니다)');
        resolve(valid);
    };
    image.onerror = () => { URL.revokeObjectURL(url); alert('이미지를 읽을 수 없습니다.'); resolve(false); };
    image.src = url;
});
